import { useHome } from "../hooks/useHome";
import React, { ReactNode, useEffect, useState } from "react";
import Spinner from "../components/Spinner";
import { Childs, Section } from "../models/LinkDetails";
import { styled } from "@mui/material/styles";
import {
  Tooltip,
  Paper,
  Avatar,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Home = () => {
  
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    justifyContent: "center",
    display: "flex",
  }));

  let { isLoading, fetchLinkDetailsForHome } = useHome();
  const [linkDetails, setLinkDetails] = useState<Section[]>([]);

  useEffect(() => {
    fetchLinkDetailsForHome(handleLinkDetails).finally();
  }, []);

  const handleLinkDetails = (response: any) => {
    setLinkDetails(response.data);
  };

  const handleSearchTextChange = (searchText : string) =>  {

  }

  const renderChild = (childs: Childs[]): ReactNode => {
    return (
      childs &&
      childs.map((child) => (
        <Link target="_blank" to={child.url} key={child.title}>
          <Item>
            <Tooltip title={child.tooltip}>
              <div style={{ textAlign: "center" }}>
                <Avatar
                  src={child.icon}
                  sx={{ width: 56, height: 56, margin: "0 auto" }}
                  variant="square"
                />
                <p>{child.title}</p>
              </div>
            </Tooltip>
          </Item>
        </Link>
      ))
    );
  };

  const renderSocialChild = (childs: Childs[]): ReactNode => {
    return (
      childs &&
      childs.map((child) => (
        <div className="col-md-6" key={child.title}>
          <div className="social-section">
            <h5>{child.title}</h5>
            <div className="social-icons">
              <Link to={child.url} target="_blank">
                <img src={`social-media/website.png`} alt="Website" />
              </Link>
              <Link to={child.linkedinUrl} target="_blank">
                <img src={`social-media/linkedin.png`} alt="LinkedIn" />
              </Link>
              <Link to={child.youtubeUrl} target="_blank">
                <img src={`social-media/youtube.png`} alt="YouTube" />
              </Link>
              <Link to={child.facebookUrl} target="_blank">
                <img src={`social-media/facebook.png`} alt="Facebook" />
              </Link>
              <Link to={child.instagramUrl} target="_blank">
                <img src={`social-media/instagram.png`} alt="Instagram" />
              </Link>
            </div>
          </div>
        </div>
      ))
    );
  };

  const renderQuickAccessToolbarChild = (childs: Childs[]): ReactNode => {
    return (
      childs &&
      childs.map((child) => (
        <div className="col-md-3" key={child.title}>
          <div className="card">
            <div className="card-body">
              <Link to={child.url} target="_blank">
                <img
                  src={`images/${child.icon}`}
                  className="card-img-top"
                  alt="Logos"
                />
                <p className="card-text">{child.title}</p>
              </Link>
            </div>
          </div>
        </div>
      ))
    );
  };

  const renderTagChild = (tags: any[]) => {
    return (
      tags &&
      tags.map((tag, index) => (
        <span key={index} className="tag">
          {tag}
        </span>
      ))
    );
  };

  const renderQuickHrmToolbarChild = (childs: Childs[]): ReactNode => {
    return (
      childs &&
      childs.map((child) => (
        <div className="col-md-3" key={child.title}>
          <div className="card">
            <img src={`images/${child.icon}`} alt={child.title} />
            <div className="card-body hrm-card-body">
              {
                <div className="tags-container">
                  {renderTagChild(child.tags)}
                </div>
              }
              <a href="#" className="btn btn-primary btn-custom" target="_blank">
                Connect
              </a>
            </div>
          </div>
        </div>
      ))
    );
  };

  const renderQuickPowerBiToolbarChild = (childs: Childs[]): ReactNode => {
    return childs.map((child) => (
      <div className="col-md-3" key={child.title}>
        <Link to={child.url} target="_blank">
          <div className="card-custom">
            <span>{child.title}</span>
          </div>
        </Link>
      </div>
    ));
  };

  const renderQuickApplicationsToolbarChild = (childs: Childs[]): ReactNode => {
    return childs.map((child) => (
      <div className="col-md-3" key={child.title}>
        <div className="card mb-2">
          <div className="card-body min-hight-140">
            <Link to={child.url} target="_blank">
              <div className="row">
                <div className="col-md-6">
                {
                  (child.icon && child.icon.includes('advantage.png')) 
                    ? <img src={child.icon} className="card-img-top advantage-logo" alt="Advantage Logo" />
                    : <img src={child.icon || 'default.png'} className="card-img-top" alt="Logos" />
                }
                </div>
                <div className="col-md-6">
                <p className="card-text pt-1">{child.title}</p>
                </div>
              </div>
            </Link>
            <p className="mt-1 mb-0">{child.tooltip}</p>
          </div>
        </div>
      </div>
    ));
  };

  const renderContent = (linkDetail: Section) => {
    if (linkDetail.sectionType === "socialMedia") {
      return <div className="row">{renderSocialChild(linkDetail.childs)}</div>;
    } else if (linkDetail.sectionType === "quickAccessToolbar") {
      return (
        <div className="row full-width">
          {renderQuickAccessToolbarChild(linkDetail.childs)}
        </div>
      );
    } else if (linkDetail.sectionType === "quickHrmToolbar") {
      return (
        <div className="row full-width">
          {renderQuickHrmToolbarChild(linkDetail.childs)}
        </div>
      );
    } else if (linkDetail.sectionType === "quickPowerBiToolbar") {
      return (
        <div className="row full-width">
          {renderQuickPowerBiToolbarChild(linkDetail.childs)}
        </div>
      );
    } else if (linkDetail.sectionType === "quickApplicationsToolbar") {
      return (
        <div className="row full-width">
          {renderQuickApplicationsToolbarChild(linkDetail.childs)}
        </div>
      );
    } else {
      return renderChild(linkDetail.childs);
    }
  };

  const arrayDataItems = linkDetails.map((linkDetail) => (
    <Accordion defaultExpanded={true} key={linkDetail.section}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <img
          src={`/header-top/${linkDetail.sectionIcon}`}
          className="header-icon"
          alt="header-icon"
        />
        <h3 className="section-title">{linkDetail.section}</h3>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={5} direction="row">
          {renderContent(linkDetail)}
        </Stack>
      </AccordionDetails>
    </Accordion>
  ));

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinner isLoading={isLoading} />
      ) : (
        <>
          {/* <div className="row banner-text-mb">
            <div className="col-md-6 text-left">
              <span className="hader-bg-text">
                😊 Welcome, hoping you have a good day!
              </span>
              <div className="input-group search-box mt-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="What are you looking for?"
                  onChange={(event) => handleSearchTextChange(event.target.value)}
                />
                <div className="input-group-append">
                  <button className="btn btn-search" type="button">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div> */}
          {arrayDataItems}
        </>
      )}
    </React.Fragment>
  );
};

export default Home;
